import { API, handleApiError } from "./utils";
const userId = localStorage.getItem('user')

export const getPendingNotifications = async () => {
    try {
        const { error, data } = await API.get(`/notification/`);
        return { errorN: error, dataN:data };
    } catch (error) {
        return handleApiError(error);
    }
};

export const sendSupportEmail = async (payload) => {
  try {
    const res = await API.post("/email_support/", payload);
    return { error: null, data: res.data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSmtpConfig = async (company_id) => {
  try {
    const { data } = await API.get("/smtp-config/", { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateSmtpConfig = async (payload, company_id) => {
  try {
    const { data } = await API.put("/smtp-config/", payload, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const testSmtpConfig = async (recipient_email, company_id) => {
  try {
    const { data } = await API.post("/smtp-config/test", { recipient_email }, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSlackConfig = async (company_id) => {
  try {
    const { data } = await API.get("/slack-config/", { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateSlackConfig = async (payload, company_id) => {
  try {
    const { data } = await API.put("/slack-config/", payload, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const testSlackConfig = async (company_id) => {
  try {
    const { data } = await API.post("/slack-config/test", null, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getSmsConfig = async (company_id) => {
  try {
    const { data } = await API.get("/sms-config/", { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateSmsConfig = async (payload, company_id) => {
  try {
    const { data } = await API.put("/sms-config/", payload, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const testSmsConfig = async (to_number, company_id) => {
  try {
    const { data } = await API.post("/sms-config/test", { to_number }, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const getTelegramConfig = async (company_id) => {
  try {
    const { data } = await API.get("/telegram-config/", { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateTelegramConfig = async (payload, company_id) => {
  try {
    const { data } = await API.put("/telegram-config/", payload, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const testTelegramConfig = async (company_id) => {
  try {
    const { data } = await API.post("/telegram-config/test", null, { params: { company_id } });
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const setNotificationsSeen = async (id) => {
    try {
        const { error, data } = await API.put(`/notification_seen/${id}`);
        return { error: error, data };
    } catch (error) {
        return handleApiError(error);
    }
};
